module.exports = __webpack_public_path__ + "static/media/custom.3a428d30.svg";